module.exports = __webpack_public_path__ + "static/img/shouqiIcon.23a8d06d.svg";